import { createFileRoute } from '@tanstack/react-router';
import { createGroupBroadcastNewRoute } from '@/lib/route-factories/group-broadcast-route';

export const Route = createFileRoute(
  '/_authed/groups/$id/admin/broadcasts/new/',
)(
  createGroupBroadcastNewRoute({
    kind: 'space',
    fromId: '/_authed/groups/$id/admin/broadcasts/new/',
  }),
);
